<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="immagine3"><span>Massimo Carlotto</span></p>
<p class="immagine4"><span>BLUES <br/>FOR OUTLAW HEARTS <br/>AND OLD WHORES</span></p>
<p class="immagine2" id="traduzione"><span><i>Translated from the Italian<br/>
    by Will Schutt</i></span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?dc38f0d8